module.exports = __webpack_public_path__ + "static/scope-7ee9333d4ad0969f8bf60f740e8d079a.png";